module.exports = __webpack_public_path__ + "img/preview-8.8a06002b.webp";